import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Mounted in AppLayout. notificationUtils.ts is a non-React module and can't
// hold a useNavigate, so the toast onClick dispatches `droneNotificationNavigate`
// and this component performs the SPA navigation. Keeping the store-write in
// notificationUtils and the navigate here means the focus-drone state is set
// before /map mounts, so ScanningMapView's focus effect picks it up on first render.
export default function BellNavBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent).detail ?? {};
      const { longitude, latitude, mac_address } = detail as {
        longitude?: number;
        latitude?: number;
        mac_address?: string | null;
      };
      // Thread the mac through nav state. ScanningMapView's focus-drone effect
      // synchronously clears store.focusDroneMac during style.load, so by the
      // time MapView's handleMapLoad runs (also on style.load, registered
      // second) the store no longer knows which drone we're focusing — without
      // this, the live-position lookup fails and the camera lands on the
      // (potentially stale) bell snapshot coords.
      navigate("/map", {
        replace: true,
        state: { fromNewDashboard: true, longitude, latitude, mac_address },
      });
    };
    window.addEventListener("droneNotificationNavigate", handler);
    return () => window.removeEventListener("droneNotificationNavigate", handler);
  }, [navigate]);

  return null;
}
